import i18n from 'i18next';
import { registerValidator } from 'core/forms';

import getIsDateTrigger from '../helpers/getIsDateTrigger';

import isOffsetRequired from './isOffsetRequired';

const isOffsetValidBasedOnTrigger = ({ fieldValue, model }) => {
  const { isRequired } = isOffsetRequired({ fieldValue, model });

  return {
    error: i18n.t('error-offset-invalid'),
    hasError: isRequired && !getIsDateTrigger(model) && fieldValue?.time_interval === 'minutes',
    isRequired,
  };
};

registerValidator('isOffsetValidBasedOnTrigger', isOffsetValidBasedOnTrigger);

export default isOffsetValidBasedOnTrigger;
